import * as React from 'react';
import { NoticeCore, } from '@core-front/notice';
import Icon from '@telia-front/icon';
const Notice = (props) => {
    const { type, className, icon, } = props;
    const BEM = () => {
        const classArray = [];
        if (type === 'recommended' || type === 'attention') {
            classArray.push('notice--' + type);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const getType = () => {
        switch (type) {
            case 'recommended':
            case 'attention':
                return undefined;
            default:
                return type;
        }
    };
    const getIcon = () => {
        switch (type) {
            case 'recommended':
                return icon || '#contact';
            default:
                return undefined;
        }
    };
    return (React.createElement(NoticeCore, Object.assign({}, props, { type: getType(), icon: getIcon(), className: BEM(), components: {
            Icon,
        } }), props.children));
};
export { Notice as default, };
